import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import api from "@/lib/api";
import { toast } from "sonner";
import { Loader2 } from "lucide-react";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const location = useLocation();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const processed = useRef(false);

  useEffect(() => {
    if (processed.current) return;
    processed.current = true;

    const hash = location.hash || "";
    const match = hash.match(/session_id=([^&]+)/);
    if (!match) {
      toast.error("Session Google introuvable");
      navigate("/login", { replace: true });
      return;
    }
    const session_id = decodeURIComponent(match[1]);

    (async () => {
      try {
        const { data } = await api.post("/auth/session", { session_id });
        if (data.token) localStorage.setItem("token", data.token);
        // Cache the account so the branded consent screen can show it on next visit
        if (data.email) {
          try { localStorage.setItem("bb_last_google", JSON.stringify({ email: data.email, name: data.name, picture: data.picture })); } catch {}
        }
        // Clear the fragment from URL
        window.history.replaceState(null, "", "/bibliotheque");
        await refresh();
        toast.success(`Bienvenue ${data.name || ""} !`);
        navigate("/bibliotheque", { replace: true });
      } catch (e) {
        toast.error(e.response?.data?.detail || "Connexion Google échouée");
        navigate("/login", { replace: true });
      }
    })();
  }, [location.hash, navigate, refresh]);

  return (
    <div className="min-h-[60vh] flex items-center justify-center">
      <div className="text-center">
        <Loader2 className="w-8 h-8 text-accent mx-auto animate-spin" />
        <p className="mt-4 text-muted-foreground text-sm">Connexion à votre compte...</p>
      </div>
    </div>
  );
}
